import React from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import LoadingButton from "./LoadingButton";

const useStyles = makeStyles((theme) => ({
  boxContent: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    flexDirection: "column",
    alignItems: "start",
  },
}));


const ConfirmActionDialog = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    confirmDialog,
    setConfirmDialog,
    children,
  } = props;

  return (
    <Dialog open={confirmDialog.isOpen} disableBackdropClick>
      <DialogTitle id="form-dialog-title">{t(confirmDialog.title)}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t(confirmDialog.subTitle)}</DialogContentText>
      </DialogContent>
      <DialogContent className={classes.boxContent}>
        {confirmDialog.childrenVisible && children}
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="outlined"
          onClick={() => setConfirmDialog({ ...confirmDialog, isOpen: false })}          
        >
          {confirmDialog.secondaryAction}
        </Button>
        <LoadingButton
          color="primary"
          onClick={confirmDialog.onConfirm}
          variant="contained"
          disabled={confirmDialog.disablePrimary}
          isLoading={confirmDialog.isLoading}
        >
          {confirmDialog.primaryAction}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

// Specifies the default values for props:
ConfirmActionDialog.defaultProps = {
  confirmDialog: {
    title: "pgPunch.tlConfirmation"
  },
};

ConfirmActionDialog.propTypes = {
  confirmDialog: PropTypes.object.isRequired,
  setConfirmDialog: PropTypes.func.isRequired,
  onClickHandle: PropTypes.func.isRequired,
};

export default ConfirmActionDialog;
